import Service from '../abstract/service'

export default class Auth extends Service {

  constructor() {
    super()

    this._usuariosCollection = this._db.collection('Usuarios')
  }

  async login(email, password) {
    try {
      await this._auth.signInWithEmailAndPassword(email, password)
      if (!this._auth.currentUser.emailVerified) {
        await this.sendMailValidation()
        throw new Error('Sua conta ainda não foi verificada, enviamos um e-mail para validação da conta, verifique sua caixa de entrada.')
      }

      let user = await this.getUserByEmail(email)
      if (!user) throw new Error('Usuário não encontrado, para ter acesso é necessário criar uma conta.')

      let validateResult = await this.validateAccount(user)
      user = validateResult

      location.reload()
      return Promise.resolve('Logado com sucesso')
    } catch (error) {
      await this.signOut()

      if (!error.code)
        return Promise.reject(error.message)
      if (error.code == 'auth/wrong-password')
        return Promise.reject('Senha digitada é inválida.')
      if (error.code == 'auth/user-not-found')
        return Promise.reject('Não foi encontrada nenhuma conta vinculada ao e-mail informado.')
      if (error.code == 'auth/too-many-requests')
        return Promise.reject('Diversas tentativas de login malsucedidas, aguarde 1 minuto para tentar novamente')
      else
        return Promise.reject('Ocorreu um erro inesperado.')
    }
  }

  async createAccount(data) {
    data.cpf = data.cpf.replace(/[^0-9]/g, '')
    data.dataCriacao = new Date()
    data.prefix = 'prod'
    data.grupoPrincipal = 'GrupoCometa'
    data.empresaPrincipal = ''
    data.papel = ''

    try {
      await this._auth.createUserWithEmailAndPassword(data.email, data.password)
      await this._auth.currentUser.updateProfile({
        displayName: data.nome,
        photoUrl: '',
        phoneNumber: data.telefone
      })

      if (await this.getUserByEmail(data.email) != null)
        throw new Error('E-mail informado já está em uso, tente outra conta de e-mail.')

      if (await this.getUserById(data.cpf) != null)
        throw new Error('CPF informado já está em uso')

      //Busca os dados de colaborador
      const _colabCollection = this._db.collection(`prod-gruposEmpresas/GrupoCometa/Colaboradores`)
      let colabRef = await _colabCollection.doc(data.cpf).get()
      if (colabRef.exists) {
        let colabData = colabRef.data()
        data.empresaPrincipal = colabData.empresas[0]
        data.papel = colabData.papel
      }

      delete data.password
      await this._usuariosCollection.doc(data.cpf).set(data)
      await this.sendMailValidation()
      await this._auth.signOut()

      return Promise.resolve('Sua conta foi criada com sucesso. Enviamos um e-mail para validação da sua conta, verifique na sua caixa de entrada.')
    } catch (error) {
      console.error(error)
      if (!error.code) {
        await this.deleteAccount()
        await this.signOut()
        return Promise.reject(error.message)
      }

      await this.signOut()

      if (error.code == 'auth/email-already-in-use')
        return Promise.reject('E-mail informado já está em uso para autenticação, tente outra conta de e-mail.')
      else
        return Promise.reject('Ocorreu um erro inesperado')
    }
  }

  async deleteAccount() {
    try {
      if (this._auth.currentUser) {
        await this._auth.currentUser.delete()
        return Promise.resolve('Conta excluida com sucesso.')
      } else {
        throw new Error('Não foi encontrado nenhuma conta autenticada para exclusão.')
      }
    } catch (error) {
      console.error(error)
      return Promise.reject(error.message)
    }
  }

  async recoveryPasswd(email) {
    try {
      await this._auth.sendPasswordResetEmail(email)
      return Promise.resolve(
        `Enviamos um e-mail para ${email} para realizar a alteração de senha`
      )
    } catch (error) {
      console.error(error)
      return Promise.reject('E-mail não está cadastrado no sistema')
    }
  }

  async getUserByEmail(email) {
    try {
      const user = await this._usuariosCollection.where('email', '==', email).get()
      if (!user.empty) {
        return {
          id: user.docs[0].id,
          ...user.docs[0].data()
        }
      }
      return null
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  async getUserByCpf(cpf) {
    try {
      const user = await this._usuariosCollection.where('cpf', '==', cpf).get()
      if (!user.empty) {
        return {
          id: user.docs[0].id,
          ...user.docs[0].data()
        }
      }
      return null
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  async getUserById(id) {
    try {
      const user = await this._usuariosCollection.doc(id).get()
      if (user.exists) {
        return {
          id,
          ...user.data()
        }
      }
      return null
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  async sendMailValidation() {
    try {
      if (!this._auth.currentUser) throw new Error('Não foi possível enviar email de validação, nenhum usuário autenticado no momento.')
      await this._auth.currentUser.sendEmailVerification()
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  async signOut() {
    try {
      if (this._auth.currentUser) {
        await this._auth.signOut()
      }
      return Promise.resolve('Logout success.')
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  async validateAccount(user) {
    try {
      if (!user.empresaPrincipal) throw new Error('Usuário não possui uma empresa principal, favor entrar em contato com administrador')
      if (!user.grupoPrincipal) throw new Error('Usuário ainda não possui grupo principal, favor entrar em contato com administrador')
      if (!user.papel) throw new Error('Usuário não possui um papel definido, favor entrar em contato com o administrador')

      let colaboradoresCollection = this._db.collection(`${user.prefix}-gruposEmpresas/${user.grupoPrincipal}/Colaboradores`)
      let colaboradorDoc = await colaboradoresCollection.doc(user.id).get()
      if (!colaboradorDoc.exists) throw new Error('Seu cadastro não está completo, favor entrar em contato com administrador')

      let colaboradorData = colaboradorDoc.data()
      if (colaboradorData.empresas.length <= 0) throw new Error('Você não possui acesso a nenhuma empresa no momento, favor entrar em contato com administrador')

      let empresasCollection = this._db.collection(`${user.prefix}-gruposEmpresas/${user.grupoPrincipal}/Empresas`)
      let empresas = []

      if (user.papel == 'Administrador' || user.papel == 'Marketing' || user.papel == 'Administrativo') {
        const empresasRef = await empresasCollection.where('ativo', '==', true).get()
        if (!empresasRef.empty) {
          for (let empresaDoc of empresasRef.docs) {
            empresas.push(empresaDoc.data())
          }
        }
      }
      else {
        for (let cnpj of colaboradorData.empresas) {
          let empresaDoc = await empresasCollection.doc(cnpj).get()
          if (empresaDoc.exists)
            empresas.push(empresaDoc.data())
        }
      }

      user.empresas = empresas
      user.colaborador = colaboradorData
      return Promise.resolve(user)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateAccount(id, data) {
    try {
      let user = this._auth.currentUser
      let userRef = await this._usuariosCollection.doc(id)

      if (!userRef.empty) {
        await userRef.update(data)
        await user.updateProfile({
          displayName: data.nome
        })
        return Promise.resolve('Atualizado com sucesso!')
      }
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  async updatePassword(newPassword) {
    let user = this._auth.currentUser
    try {
      await user.updatePassword(newPassword)
      return Promise.resolve('Senha alterada com sucesso!')
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

}
